import {
  faBars,
  faEnvelopeOpen,
  faUserPlus,
  faChartLine,
  faBullhorn,
  faRocket,
  faRoute,
  faUsers,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useSidebar from "../../../hooks/useSidebar";

const AnalyticsOverview = () => {
  const { onShowSidebar } = useSidebar();

  const stats = [
    {
      title: "Emails Sent",
      value: "12,450",
      icon: faEnvelopeOpen,
      color: "text-primary",
    },
    {
      title: "New Subscribers",
      value: "1,289",
      icon: faUserPlus,
      color: "text-success",
    },
    {
      title: "Open Rate",
      value: "46.3%",
      icon: faChartLine,
      color: "text-warning",
    },
  ];

  // Campaign Analytics
  const campaignStats = [
    {
      title: "Total Campaigns",
      value: "28",
      icon: faBullhorn,
    },
    {
      title: "Emails Sent",
      value: "58,740",
      icon: faEnvelopeOpen,
    },
    {
      title: "Avg. Open Rate",
      value: "41.2%",
      icon: faChartLine,
    },
    {
      title: "Avg. Click Rate",
      value: "17.9%",
      icon: faRocket,
    },
  ];

  // Journey Analytics
  const journeyStats = [
    {
      title: "Total Journeys",
      value: "12",
      icon: faRoute,
    },
    {
      title: "Active Journeys",
      value: "7",
      icon: faCheckCircle,
    },
    {
      title: "Contacts in Journey",
      value: "3,218",
      icon: faUsers,
    },
    {
      title: "Completion Rate",
      value: "69%",
      icon: faChartLine,
    },
  ];

  return (
    <div>
      <div className="main-title d-flex align-items-center justify-content-between mb-4">
        <h2 className="d-flex align-items-center">
          <span
            className="d-lg-none cursor-pointer me-2"
            onClick={() => onShowSidebar()}
          >
            <FontAwesomeIcon icon={faBars} />
          </span>
          Analytics Overview
        </h2>
      </div>

      {/* Overview Cards */}
      <div className="row mb-4">
        {stats.map((stat, index) => (
          <div className="col-md-4 mb-3" key={index}>
            <div className="card shadow-sm p-3 h-100">
              <div className="d-flex align-items-center">
                <div className={`me-3 fs-3 ${stat.color}`}>
                  <FontAwesomeIcon icon={stat.icon} />
                </div>
                <div>
                  <h6 className="mb-1">{stat.title}</h6>
                  <h4 className="fw-bold">{stat.value}</h4>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Campaign Analytics */}
      <h4 className="mb-3">Campaign Analytics</h4>
      <div className="row mb-4">
        {campaignStats.map((item, index) => (
          <div className="col-md-3 mb-3" key={index}>
            <div className="card p-3 h-100 shadow-sm">
              <div className="d-flex align-items-center">
                <FontAwesomeIcon icon={item.icon} className="me-3 fs-4 text-info" />
                <div>
                  <h6 className="mb-1">{item.title}</h6>
                  <h5 className="fw-bold">{item.value}</h5>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Journey Analytics */}
      <h4 className="mb-3">Journey Analytics</h4>
      <div className="row">
        {journeyStats.map((item, index) => (
          <div className="col-md-3 mb-3" key={index}>
            <div className="card p-3 h-100 shadow-sm">
              <div className="d-flex align-items-center">
                <FontAwesomeIcon icon={item.icon} className="me-3 fs-4 text-secondary" />
                <div>
                  <h6 className="mb-1">{item.title}</h6>
                  <h5 className="fw-bold">{item.value}</h5>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsOverview;
